export default {
    Aruba: "Aruba",
    Bolivia: "Bolivia",
    Brazil: "Brasil",
    Colombia: "Colombia",
    "Dominican Republic": "República Dominicana",
    Ecuador: "Ecuador",
    England: "Inglaterra",
    "French Guiana": "Guayana Francesa",
    Mexico: "México",
    Nicaragua: "Nicaragua",
    Panama: "Panamá",
    Paraguay: "Paraguay",
    "Puerto Rico": "Puerto Rico",
    "Saint Martin": "San Martín",
    "Trinidad and Tobago": "Trinidad y Tobago",
    "United States": "Estados Unidos",
    Uruguay: "Uruguay",
    Venezuela: "Venezuela"
}
